import axios from "axios";
import { DataResponse } from "models/common/responseObjects";
export class PermissionsApi {
    static PermissionNames = async () => axios.get<DataResponse<string[]>>(`api/v1/Permissions/PermissionNames`);
}